import api from './api';
// import { API_BASE_URL } from '../config';

export interface Tag {
  level1: string;
  level2: string | null;
  level3: string | null;
}

export interface Note {
  _id: string;
  text: string;
  tags: Tag[];
  comment?: string;
  createdAt: string;
  updatedAt: string;
  url: string;
  title: string;
  image?: {
    path: string;
    timestamp: string;
  };
}

export interface SimilarNote {
  _id: string;
  title: string;
  text: string;
  similarity: number;
  createdAt: string;
  tags: Tag[];
  url: string;
}

export const notesApi = {
  fetchNotes: (tag: string | null | undefined, page: number = 1, limit: number = 20) => {
    const url = tag 
      ? `/notes/bytag/${encodeURIComponent(tag)}` 
      : '/notes';
    
    console.log('Fetching notes from:', url, 'page:', page, 'limit:', limit);
    return api.get<{
      notes: Note[];
      total: number;
      hasMore: boolean;
    }>(url, {
      params: {
        page,
        limit
      }
    });
  },
  
  createNote: (note: { text: string; tags: Tag[] }) => {
    const now = new Date();
    const urlDate = now.toISOString().split('T')[0];
    const urlTime = now.toTimeString().split(' ')[0].replace(/:/g, '-');
    const formattedDate = now.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(/\//g, '-');

    const noteData = {
      ...note,
      url: `note://${urlDate}/${urlTime}`,
      // TODO: Multiple language support
      title: `Manual Record - ${formattedDate}`,
      comment: ''
    };

    return api.post<Note>('/notes', noteData);
  },
  
  updateNote: (id: string, note: Partial<Note>) => 
    api.put<Note>(`/notes/${id}`, note),
  
  deleteNote: (id: string) => 
    api.delete(`/notes/${id}`),
  
  searchNotes: (searchTerm: string) => 
    api.get<Note[]>('/notes/search', {
      params: { q: searchTerm }
    }),
}; 

export const getNotes = async (params?: any) => {
  const response = await api.get('/notes', { params });
  return response.data;
}; 

export async function getSimilarNotes(noteId: string): Promise<SimilarNote[]> {
  console.log('[similar notes] Requesting similar notes for:', noteId);
  try {
    const response = await api.get(`/similar/${noteId}`);
    console.log('[similar notes] Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[similar notes] Error fetching similar notes:', error);
    throw error;
  }
}